import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import HomeCard from '../../components/HomeCard';
// import { colors, typography } from '../../styles';

const styles = css`
`;

function CommunityDetailHomes({ homes }) {
  return (
    <div className={styles}>
      {
        homes.length > 0 &&
        <div className="DetailSection">
          <h3 className="DetailSection_heading" id="homes"><span>Homes</span> For Sale</h3>
          <div className="container">
            <div className="row p-0 justify-content-center">
              {
                orderBy(homes, 'sqft', 'desc').map(home => (
                  <div key={home._id} className="col-sm-12 col-xl-6">
                    <HomeCard home={home} />
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

CommunityDetailHomes.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  homes: true,
})(CommunityDetailHomes);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Homes.js